import { useParams } from 'react-router-dom';
import { BatchProvider } from '../../context/VoucherBatchProvider';
import BatchProgress from './BatchProgress';

const BatchStatus = () => {
  const { id } = useParams() as { id: string };

  return (
    <BatchProvider id={id}>
      <BatchProgress />
    </BatchProvider>
  );
};

export default BatchStatus;
